module.exports = __webpack_public_path__ + "4f3f08640009e3feb795e1fbfe0cea2f.MP3";